// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VeeValidate from 'vee-validate'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.css'
import store from './store'
import moment from 'moment'
import Vue2Filters from 'vue2-filters'

import App from './App'
import router from './router'

Vue.use(Vuetify, {
  theme: {
    primary: '#007d41',
    primaryDarker: '#004f18',
    primaryLighter: '#48ad6d',
    secondary: '#2962ff',
    accent: '#2962ff',
    accentDarker: '#0039cb',
    accentLighter: '#768fff'
  }
})

Vue.config.productionTip = false

const config = {
  errorBagName: 'errors', // change if property conflicts
  fieldsBagName: 'fields',
  delay: 0,
  locale: 'en',
  dictionary: null,
  strict: true,
  classes: false,
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'valid', // model is valid
    invalid: 'invalid', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty' // control has been interacted with
  },
  events: 'input|blur',
  inject: true,
  validity: false,
  aria: true
}
Vue.use(VeeValidate, config)

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY hh:mm:ss A')
  }
})

Vue.filter('phone', function (phone) {
  return phone.replace(/[^0-9]/g, '')
              .replace(/(\d{3})(\d{2})(\d{3})(\d{3})/, '+$1 $2 $3 $4')
})

Vue.use(Vue2Filters)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js